import React, { useEffect, useContext } from "react";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import "../FinancialCalculators.css";
import LoanBalanceTransferCalculators from "./LoanBalanceTransferCalculators";
import { Helmet } from "react-helmet-async";

const BalanceTransferCalculators = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px)");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Balance Transfer Calculators - Minemi</title>
      </Helmet>
      <div id="financial_calculator__container" className="w-100">
        {/* Hero Section Starts Here */}
        <section id="hero_section" className="w-100">
          <p className="pages_links bg-transparent links ">
            <Link
              to="/"
              underline="hover"
              className="bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Home
            </Link>
            &nbsp;
            <span
              className="d-none d-md-inline bg-transparent ps-1 px-1 "
              style={{
                color: "#59266D",
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
              }}
            >
              &gt;
            </span>
            &nbsp;
            <Link
              to="/calculators"
              underline="hover"
              className="d-none d-md-inline bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Calculators
            </Link>
            &nbsp;
            <span
              className="d-none d-md-inline bg-transparent ps-1 px-1 "
              style={{
                color: "#59266D",
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
              }}
            >
              &gt;
            </span>
            &nbsp;
            <Link
              to="/calculators/balance-transfer-calculators"
              underline="hover"
              className="d-none d-md-inline fw-bold bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Balance Transfer Calculator
            </Link>
          </p>
          <div
            id="hero_container"
            className="d-flex flex-column flex-md-row align-items-center justify-content-between  w-100"
          >
            <div id="" className="hero-headings">
              <h1>MinEmi Balance Transfer Calculators</h1>
              <p className="mt-2">
                Calculate minimum EMI for balance transfers with ease and
                accuracy.
              </p>
            </div>
            <div>
              <img
                src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/hero_img-1745056661887.webp"
                alt="hero_img"
                loading="lazy"
                className="hero_img"
              />
            </div>
          </div>
        </section>
        {/* Hero Section Ends Here */}

        <section id="main-section" className="">
          <LoanBalanceTransferCalculators />
        </section>
      </div>
    </>
  );
};

export default BalanceTransferCalculators;
